/**
 * Name of the event that tells the header's token meter to refetch.
 *
 * It lives in its own module rather than in Layout.js so that pages rendered *inside*
 * Layout can import it without creating a cycle (Layout -> CopilotSidebar -> a page ->
 * Layout). ES modules tolerate cycles, but a `const` read during one resolves as
 * undefined, and the failure would be a counter that silently stops updating.
 */
export const BUDGET_CHANGED = 'bagent:budget-changed';

/** Fire after any call that spends tokens. */
export function notifyBudgetChanged() {
  window.dispatchEvent(new Event(BUDGET_CHANGED));
}
